import { useHistory } from "react-router";
import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { GlobalContext } from "../../../../global/context/Provider";
import Hamburguer from "../../../assets/images/generico/Hamburguer";

import {
  logoutPacienteDefault,
  setUserSelectEditar,
} from "../../../context/Actions/paciente/paciente";
import IconBlack from "../../../assets/images/generico/IconBack";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import "./HeaderBarProfile.css";
import { wsGetGrupoFamiliar } from "../../../context/Actions/grupoFamiliar/grupoFamiliar";
import { dropdownFamiliares } from "../../Turnos/ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import { showModal } from "../../../context/Actions/modal/modal";
import SalirIcon from "../../../assets/images/generico/SalirIcon";

import { modeClick } from "../../../../global/context/action/mode/mode";
import BurguerMobile from "../../Genericos/BurguerMobile/BurguerMobile";
import { MenuContainerMobile } from "../../Genericos/HeaderbarHome/localStyle";

const HeaderBarProfile = ({ handleClickLogout, onChangeFamiliar }) => {
  const {
    grupoFamiliarDispatch,
    pacienteDispatch,
    pacienteState,
    listaFamiliaresState,
    modalDispatch,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, modeDispatch, modeState } = useContext(GlobalContext);

  const history = useHistory();
  const handleClickVolver = () => {
    // resetPaciente()(pacienteDispatch);
    logoutPacienteDefault()(pacienteDispatch);
    // vale la pena agregar un logoutPaciente ? no vamos a usar los pacientes?
    history.goBack();
  };

  const pacienteAuth = authState?.auth?.data?.paciente;

  const onPerfilFamiliaresChange = (e) => {
    const idUser = pacienteAuth?.codigo;

    if (!idUser) {
      setUserSelectEditar(false)(pacienteDispatch);
      return;
    }

    if (e !== "") {
      if (idUser === e.id) {
        setUserSelectEditar(false)(pacienteDispatch);
        onChangeFamiliar();
      } else if (e.edicionPerfil && idUser !== e.id) {
        setUserSelectEditar({ id: e.id, paciente: e.paciente })(
          pacienteDispatch
        );
        onChangeFamiliar();
      } else if (!e.edicionPerfil && idUser !== e.id) {
        showModal(
          "Perfil/ModalAlertGrupoFamiliar/ModalAlertGrupoFamiliar",
          {},
          "centro"
        )(modalDispatch);
        setUserSelectEditar(false)(pacienteDispatch);
      }
    }
  };

  useEffect(() => {
    wsGetGrupoFamiliar(true)(grupoFamiliarDispatch);
    //eslint-disable-next-line
  }, []);

  // Hacer click para poder cambiar de modo
  const handleMode = () => {
    modeClick()(modeDispatch);
  };

  // Nuevo menú
  // Header Bar copiado
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };
  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  let config = localStorage.getItem("config");

  return (
    <React.Fragment>
      <div className="ptur-HeaderbarProfile c-white">
        {/* HEADER BAR DE PORTAL  */}
        <BurguerMobile
          onCloseBurguerMobile={onCloseBurguerMobile}
          showBurguerMobile={showBurguerMobile}
        />

        <div className="ptur-back">
          <button className="ptur-btnBack" onClick={() => handleClickVolver()}>
            <IconBlack />
            <span className="ptur-txtBack rb18m">VOLVER</span>
          </button>
        </div>
        <div
          onClick={onShowBurguerHandle}
          className="ptur-burguerPerfil pointer"
        >
          <MenuContainerMobile>
            <Hamburguer />
          </MenuContainerMobile>
        </div>
        <div className="ptur-search">
          <div className="item-1">
            <span className="ptur-lblSearch rb18m">Ver</span>
          </div>
          <div className="item-2">
            <Dropdown
              onChange={onPerfilFamiliaresChange}
              campoCodigo="id"
              descripcion="nombre"
              valor={
                !pacienteState.paciente.userSelect.pacienteSeleccionado
                  ? pacienteAuth?.codigo ?? ""
                  : pacienteState.paciente.userSelect.pacienteSeleccionado.id
              }
              datos={dropdownFamiliares(
                listaFamiliaresState,
                authState,
                "EditarPerfil"
              )}
              heightLista={"auto"}
            />
          </div>
        </div>
        {/* <div className="ptur-chooseTheme">
          <span className="ptur-chooseTheme-texto rb18m noSeleccionable">
            Utilizar modo silver
          </span>
          <div className="ptur-chooseTheme-toggle" onClick={handleMode}>
            <BotonToggle toggleTheme={true}  active={modeState.mode.value}/>
          </div>
        </div> */}
        <div className="ptur-logout noSeleccionable">
          <button className="ptur-btnLogOut" onClick={handleClickLogout}>
            <SalirIcon color={"var(--color-white)"} />
            <span className="ptur-txtLogOut rb16m c-white">Salir</span>
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HeaderBarProfile;
